import { Container } from '@mantine/core';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { ConfirmationStep } from '@apple/features/cart-retail/components/steps/confirmation';

const schema = z.object({
	salesOrderNumber: z.string(),
});

export const Route = createFileRoute('/_authed/cart/confirmation/$salesOrderNumber')({
	validateSearch: z.object({ cartId: z.string().nullable() }),
	params: {
		parse: x => schema.parse(x),
		stringify: ({ salesOrderNumber }) => ({ salesOrderNumber }),
	},
	component: RouteComponent,
	beforeLoad: ({ params, search }) => {
		if (!params.salesOrderNumber || !search.cartId) {
			throw redirect({ to: '/cart' });
		}
		return { cartId: search.cartId };
	},
});

function RouteComponent() {
	const { salesOrderNumber } = Route.useParams();
	const { cartId } = Route.useRouteContext();

	return (
		<Container size='xl' p='md' mt={'var(--app-shell-header-height)'}>
			<ConfirmationStep cartId={cartId} salesOrderNumber={salesOrderNumber} />
		</Container>
	);
}
